import { render } from "./DownloadPopup.vue?vue&type=template&id=9777e9ba&scoped=true"
import script from "./DownloadPopup.vue?vue&type=script&lang=js"
export * from "./DownloadPopup.vue?vue&type=script&lang=js"

import "./DownloadPopup.vue?vue&type=style&index=0&id=9777e9ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9777e9ba"]])

export default __exports__